export let netDaniaThemes = {
  uf1: {
    name: 'Uf1',
    backgroundColor: 'transparent',
    axis: {
      xAxis: {
        edgeLineWidth: 1,
        edgeColor: 'transparent',
        gridLineWidth: 1,
        gridLineColor: 'transparent',
        fontColor: 'white',
      },
      yAxis: {
        edgeLineWidth: 1,
        edgeColor: 'transparent',
        gridLineWidth: 1,
        gridLineColor: 'transparent',
        fontColor: 'white',
      },
    },
    horizontalLine: {
      lineColor: 'rgb(41,38,61)',
      lineDash: '[4,5]',
    },
    plots: {
      candleStick: {
        up: {
          borderColor: 'rgb(144,224,255)',
          bodyColor: 'rgb(144,224,255)',
          wickColor: 'rgb(32,30,63)',
        },
        even: {
          borderColor: 'rgb(140,193,118)',
          bodyColor: 'rgb(140,193,118)',
          wickColor: 'rgb(73,162,162)',
        },
        down: {
          borderColor: 'rgb(64,115,205)',
          bodyColor: 'rgb(64,115,205)',
          wickColor: 'rgb(34,32,68)',
        },
      },
    },
  },
  uf2: {
    name: 'Uf2',
    backgroundColor: 'transparent',
    axis: {
      xAxis: {
        edgeLineWidth: 1,
        edgeColor: 'transparent',
        gridLineWidth: 1,
        gridLineColor: 'transparent',
        fontColor: 'white',
      },
      yAxis: {
        edgeLineWidth: 1,
        edgeColor: 'transparent',
        gridLineWidth: 1,
        gridLineColor: 'transparent',
        fontColor: 'white',
      },
    },
    horizontalLine: {
      lineColor: 'rgb(41,38,61)',
      lineDash: '[4,5]',
    },
    plots: {
      candleStick: {
        up: {
          borderColor: 'rgb(77,83,193)',
          bodyColor: 'rgb(77,83,193)',
          wickColor: 'rgb(39,39,83)',
        },
        even: {
          borderColor: 'rgb(140,193,118)',
          bodyColor: 'rgb(140,193,118)',
          wickColor: 'rgb(73,162,162)',
        },
        down: {
          borderColor: 'rgb(255,203,86)',
          bodyColor: 'rgb(255,203,86)',
          wickColor: 'rgb(50,42,52)',
        },
      },
    },
  },
  uf3: {
    name: 'Uf3',
    backgroundColor: 'transparent',
    axis: {
      xAxis: {
        edgeLineWidth: 1,
        edgeColor: 'transparent',
        gridLineWidth: 1,
        gridLineColor: 'transparent',
        fontColor: 'white',
      },
      yAxis: {
        edgeLineWidth: 1,
        edgeColor: 'transparent',
        gridLineWidth: 1,
        gridLineColor: 'transparent',
        fontColor: 'white',
      },
    },
    horizontalLine: {
      lineColor: 'rgb(41,38,61)',
      lineDash: '[4,5]',
    },
    plots: {
      candleStick: {
        up: {
          borderColor: 'rgb(77,83,193)',
          bodyColor: 'rgb(77,83,193)',
          wickColor: 'rgb(39,39,83)',
        },
        even: {
          borderColor: 'rgb(140,193,118)',
          bodyColor: 'rgb(140,193,118)',
          wickColor: 'rgb(73,162,162)',
        },
        down: {
          borderColor: 'rgb(169,96,238)',
          bodyColor: 'rgb(169,96,238)',
          wickColor: 'rgb(43,34,70)',
        },
      },
    },
  },
}